import {useQuery} from 'react-query';
import {STORAGE_OBJECTS_QUERY_KEY} from '../init/constants';
import {APIClient} from '../backend/ApiClient';
import {useContext} from 'react';
import {AuthContext} from '../context/AuthContext';
import {config} from '../init/config';
import {SearchResultDTO} from '../models/dto/SearchResultDTO';
import {getEmptySearchResultDTO} from '../utils/DtoUtils';

export const useGetSearchResult = (
    isTemplatesInitialized: boolean,
    country: string,
    language: string,
    path: string,
    page: number,
    pageSize: number,
    sortType: string,
    sortOrder: string,
    search: string | null,
    fileId: string | null,
    fileTypes: string[] | null,
    noOfDays: number,
    isFavorite: boolean,
    isPublic: boolean,
    objectType: string,
) => {
    const {isAuthenticated} = useContext(AuthContext);
    const apiClient = APIClient();

    if ((!isTemplatesInitialized) || (page < 1) || (pageSize < 1)) {
        return useQuery(
            [STORAGE_OBJECTS_QUERY_KEY, country, language, path, page, pageSize, sortType, sortOrder, search, fileId, fileTypes, noOfDays, isFavorite, isPublic, objectType],
            (): Promise<SearchResultDTO> => Promise.resolve(getEmptySearchResultDTO())
        );
    }

    return useQuery(
        [STORAGE_OBJECTS_QUERY_KEY, country, language, path, page, sortType, sortOrder, search, fileId, fileTypes, noOfDays, isFavorite, isPublic, objectType, pageSize],
        () => apiClient.getStorageObjects(country, language, path, page, sortType, sortOrder, search, fileId, fileTypes, noOfDays, isFavorite, isPublic, objectType, pageSize),
        {
            retry: 1,
            enabled: config.DLS_AUTHENTICATION_ACTIVE ? isAuthenticated : true
        }
    );
};
